<template>
  <div class="wh100">
      <xh-filter-layout title="解决方案" :leftVisible="true">
          <template slot="left">
              <el-tree class="filter-tree" node-key="id" :data="data" default-expand-all :expand-on-click-node="false" ref="tree" @node-click="treeClick" highlight-current></el-tree>
          </template>
          <template slot="filter">
              <el-form :inline="true" size="medium">
                  <el-form-item>
                      <el-button type="primary" @click="query" icon="el-icon-search">查询</el-button>
                  </el-form-item>
                  <el-form-item>
                      <el-button class="el-icon-plus" type="primary" @click="edit(null)">添加</el-button>
                  </el-form-item>
              </el-form>
          </template>
          <template #content>
              <MyTable ref="mytable" :url="table.url" :params="form" :method="table.method" stripe border fit :customSort="true">
                  <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                  <el-table-column prop="parent_name" label="所属分类" align="center" sortable></el-table-column>
                  <el-table-column prop="business_name" label="方案名称" align="center" sortable></el-table-column>
                  <el-table-column prop="sort" label="排序" align="center" sortable width="60"></el-table-column>
                  <!--<el-table-column prop="is_show_index" label="展示到首页" align="center" sortable width="100">
                      <template slot-scope="scope">
                          {{scope.row.is_show_index===1?"是":"否"}}
                      </template>
                  </el-table-column>-->
                  <el-table-column label="操作" align="center" width="100">
                      <template slot-scope="scope">
                          <el-tooltip effect="dark" content="修改" placement="top">
                              <el-button circle type="warning" icon="el-icon-edit" size="mini" @click="edit(scope.row)"></el-button>
                          </el-tooltip>
                          <el-tooltip effect="dark" content="删除" placement="top">
                              <el-button circle type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)"></el-button>
                          </el-tooltip>
                      </template>
                  </el-table-column>
              </MyTable>
          </template>
      </xh-filter-layout>
    <xh-dialog :title="dialog.title" :visible.sync="dialog.visible" width="70%" height="90%" :close-on-click-modal="false" @closed="closeModal">
      <SolutionEdit ref="editRef" v-if="dialog.visible" :data="dialog.editRow" @closeModal="closeModal" center></SolutionEdit>
    </xh-dialog>
  </div>
</template>
<script>
import XhFilterLayout from "@/components/XhComponents/XhFilterLayout";
import MyPanel from "@/components/Pannel/Pannel";
import MyTable from "@/components/XhComponents/XhPageTable";
import SolutionEdit from "./components/SolutionEdit";
    export default {
        components: { XhFilterLayout, MyPanel, MyTable, SolutionEdit },
        data() {
            return {
                title: '',
                form: {
                    treePath: "",
                    level: 4,
                    businessType: "解决方案"
                },
                table: {
                    method: "POST",
                    url: "/Business/getData",
                    pageSize: 50,
                },
                dialog: {
                    title: "添加",
                    visible: false,
                    editRow: {}
                },
                data: [],
                id: "0",
                name: "",
                treePath: "0",
                level: "0"
            }
        },
        methods: {
            query() {
                this.$refs.mytable.reload();
            },
            edit(row) {
                let that = this;
                if (row == null) {
                    if (parseInt(that.level) != 3) {
                        that.$message.error("请选择左侧第3级添加方案");
                        return false;
                    }
                    that.dialog.title = "添加";
                    that.dialog.editRow = {
                        id: that.$util.guid(),
                        business_name: "",
                        parent_id: that.id,
                        parent_name: that.name,
                        business_type: "解决方案",
                        tree_path: that.treePath,
                        level: that.level,
                        is_show_index: 0,
                        business_desc: "",
                        business_function: "",
                        business_index: "",
                        business_field: "",
                        sort: 1
                    };
                } else {
                    that.dialog.title = "修改";
                    that.dialog.editRow = row;
                }
                that.dialog.visible = true;
            },
            //关闭弹出页面
            closeModal() {
                this.dialog.visible = false;
                this.$nextTick(function () { this.query(); });
            },
            deleteRow(row) {
                let that = this;
                that.$confirm("删除后无法恢复, 确定要删除吗?", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" })
                    .then(() => {
                        that.$api.post("/Business/deleteData", { id: row.id },
                            function (res) {
                                if (res.code === "200") {
                                    that.query();
                                    that.$message.success("删除成功");
                                } else {
                                    that.$message.error("删除失败");
                                }
                            },
                            function (res) {
                                //that.$message.error("服务器异常，删除出错");
                            }
                        );
                    })
                    .catch(() => {
                    });
            },
            getDataTree() {
                let that = this;
                that.$api.post("/Business/getDataTree", { businessType: "解决方案" },
                    function (res) {
                        that.data = [];
                        if (res.code === "200") {
                            that.data = res.data;
                        }
                        that.$nextTick(() => {
                            that.$refs.tree.setCurrentKey(that.id);
                        });
                    },
                    function (res) {
                        //that.$message.error("服务器异常，删除出错");
                    }
                );
            },
            //树点击事件
            treeClick(obj, node, com) {
                this.id = obj.id;
                this.name = obj.label;
                this.treePath = obj.treePath;
                this.level = obj.code;
                this.form.treePath = this.treePath;
                this.query();
            },
        },
        computed: {},
        mounted() { },
        created() { this.getDataTree(); },
        watch: {},
    }
</script>
<style scoped>
    /deep/.left-content {
        overflow-y: auto;
    }
</style>